import { IFooterItems } from 'app/layouts/full/footer/footer.model'
import { AppRoutes } from 'app/app.routes'

export const footerMenuItems: IFooterItems = [
    { name: `support`, href: AppRoutes.support },
    { name: `terms`, href: AppRoutes.terms },
    // { name: `privacy`, href: AppRoutes.privacy },
]
